// 過濾沒有發送權限的全域點數
export const filterNoDepositGlobalPool = (list = []) =>
    list.filter(
        pool => !Boolean(pool?.isGlobal) || (Boolean(pool?.isGlobal) && Boolean(pool?.allowDeposit))
    );

// 過濾沒有扣除權限的全域點數
export const filterNoWithdrawGlobalPool = (list = []) =>
    list.filter(
        pool =>
            !Boolean(pool?.isGlobal) || (Boolean(pool?.isGlobal) && Boolean(pool?.allowWithdraw))
    );

// 過濾沒有扣除與發送權限的全域點數
export const filterNoWithdrawDepositGlobalPool = (list = []) =>
    list.filter(
        pool =>
            !Boolean(pool?.isGlobal) ||
            (Boolean(pool?.isGlobal) && Boolean(pool?.allowDeposit) && Boolean(pool?.allowWithdraw))
    );
